import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { Chats } from '@/features/chats'

export const Route = createFileRoute('/_authenticated/chats/')({
  beforeLoad: requireAdmin,
  component: Chats,
})
